import ActionTypes        from '../../ActionTypes';
import { Action }         from 'redux';
import {
    readData,
    writeData
}                         from '../../services/StorageService';
import { getSession }     from '../../services/SessionService';
import {
    DynamicFieldInfo,
    FieldName
}                         from '../../types';
import {
    MessageTemplatesList,
    MessageTemplate,
    MessageTemplateField
}                         from '../MessageTemplatesList/MessageTemplatesListTypes';

export interface CustomFieldsMapAction extends Action {
    messageTemplates: MessageTemplatesList;
    dynamicFieldInfo: DynamicFieldInfo;
}

export interface CustomFieldsUpdateAction extends Action {
    fieldKey: string;
    editedValue: string;
}

export interface CustomFieldsSelectAction extends Action {
    selectedField: string;
    templateId: string;
}

export interface CustomFieldsValidateAction extends Action {
    messageTemplate?: MessageTemplate;
}

export interface TemplateKeys {
    key: {
        fields: string[],
        template: MessageTemplate
    }
}

const getStorageId = async (fieldName: string): Promise<string> => {
    const session = await getSession();

    return (fieldName === 'dealership') ? session.dealer_id : session.id;
};

const writeToLocal = async (key: string, value: string): Promise<string> => {
    const storageId = await getStorageId(key);

    return writeData(`${key}_${storageId}`, value);
};

const readFromLocal = async (key: string): Promise<string> => {
    const storageId = await getStorageId(key);

    return readData(`${key}_${storageId}`);
};

const getFieldsValue = ({ name }: MessageTemplateField): Promise<FieldName> => readFromLocal(name);

const getMessageFields = async (messageTemplate: MessageTemplate) => await Promise.all(messageTemplate.template.fields.map(getFieldsValue));

const getLocalData = async (messageTemplates: MessageTemplatesList): Promise<FieldName[][]> => await Promise.all(messageTemplates.map(getMessageFields));

export const resetCustomFields = () => ({
    type: ActionTypes.CUSTOM_FIELDS_RESET
});

export const mapCustomFields = (messageTemplates: MessageTemplatesList, dynamicFieldInfo: DynamicFieldInfo) => async(dispatch) => {
    const localData = await getLocalData(messageTemplates);

    dispatch({
        type: ActionTypes.CUSTOM_FIELDS_MAP,
        localData,
        messageTemplates,
        dynamicFieldInfo,
    });
};

export const updateCustomField = (fieldKey: string, editedValue: string, focusChange?: boolean) => async(dispatch) => {
    // ONLY store values for salesRepName, dealership, and carrier fields
    if (/^(salesRepName|dealership|carrier)$/.test(fieldKey)) {
        await writeToLocal(fieldKey, editedValue);
    }
    dispatch({
        type: ActionTypes.CUSTOM_FIELDS_UPDATE,
        fieldKey,
        editedValue,
        focusChange
    });
};

export function validateCustomFields(messageTemplate: MessageTemplate): CustomFieldsValidateAction {
    return {
        type: ActionTypes.CUSTOM_FIELDS_VALIDATE,
        messageTemplate
    };
}

export function selectCustomField(selectedField: string, templateId: string): CustomFieldsSelectAction {
    return {
        type: ActionTypes.CUSTOM_FIELDS_SELECT,
        selectedField,
        templateId
    };
}



// WEBPACK FOOTER //
// ./src/sections/CustomFields/CustomFieldsActions.ts